import {Prescriptions} from './prescription.model';

export class PrescriptionView {
  type: string;
  tag: string;
  prescriptions: Prescriptions[];
}
